<div
     snAssistantSurface="test"
     i18n-surfaceTitle="@@test.surface"
     surfaceTitle="Evaluation test" class="test-edit-page" [class.embedded]="isEmbedded()">

  <!-- Type tabs (header) -->
  <nav class="type-tabs" snAssistantAnchor="type">
    @for (tab of typeTabs; track tab.value) {
      <!-- У созданного теста тип менять нельзя: уход с E2E молча обнуляет
           персону со всеми моделями и голосом, а накопленная история
           прогонов начинает смешивать вердикты двух разных природ —
           текстовую оценку и настоящий звонок. Неактивную вкладку не
           прячем: пусть видно, какого типа тест и почему второй выбор
           недоступен. -->
      <button
        type="button"
        class="type-tab"
        [class.active]="test().type === tab.value"
        [disabled]="isUpdateMode() && test().type !== tab.value"
        [pTooltip]="isUpdateMode() ? typeLockedHint : ''"
        tooltipPosition="bottom"
        (click)="setType(tab.value)">
        <span>{{ tab.label }}</span>
        @if (tab.alpha) {
          <p-tag value="Alpha" severity="info" class="alpha-tag"></p-tag>
        }
      </button>
    }
  </nav>

  <!-- Переключатель панелей. Виден только на узком экране: там обе
       колонки встают друг под друга, и стартовый диалог занимает пол-экрана
       ещё до того, как доберёшься до настроек. На десктопе панели рядом, и
       переключать нечего — CSS его прячет. -->
  <nav class="pane-tabs">
    <button
      type="button"
      class="pane-tab"
      [class.active]="mobilePane() === 'settings'"
      (click)="mobilePane.set('settings')"
      i18n="@@tests.pane.settings">Settings</button>
    <button
      type="button"
      class="pane-tab"
      [class.active]="mobilePane() === 'conversation'"
      (click)="mobilePane.set('conversation')">
      <span i18n="@@tests.pane.conversation">Conversation</span>
      @if ((test().seed_messages ?? []).length; as n) {
        <p-tag [value]="n.toString()" severity="secondary"></p-tag>
      }
    </button>
  </nav>

  @if (isLoading()) {
    <div class="loading"><p-progressSpinner></p-progressSpinner></div>
  } @else {
    <div class="test-edit-body" [class.show-conversation]="mobilePane() === 'conversation'">

      <!-- LEFT: settings -->
      <section class="settings-pane">
        <div class="form-field">
          <label i18n="@@tests.field.name">Test name</label>
          <input
            [snAssistantId]="F.name"
            pInputText type="text"
            i18n-placeholder="@@tests.field.name.placeholder"
            placeholder="Test name"
            name="name"
            [ngModel]="test().name"
            (ngModelChange)="setField('name', $event)">
        </div>

          <div class="form-field">
            <label i18n="@@tests.field.scenario">Describe simulated user scenario</label>
            <textarea
              [snAssistantId]="F.simulatedUserScenario"
              pTextarea rows="3" [autoResize]="true"
              class="test-edit-textarea"
              i18n-placeholder="@@tests.field.scenario.placeholder"
              placeholder="You are a customer who wants to…"
              name="simulated_user_scenario"
              [ngModel]="test().simulated_user_scenario"
              (ngModelChange)="setField('simulated_user_scenario', $event)">
            </textarea>
          </div>

          @if (isE2E()) {
            <!-- Судья у полного прогона необязателен: иногда надо лишь
                 доказать, что агент держит звонок от начала до конца.
                 Переключатель стоит ДО критерия успеха, потому что решает,
                 нужен ли тот вообще. -->
            <div class="form-field">
              <div class="switch-field">
                <div class="switch-content">
                  <label class="switch-label" i18n="@@tests.field.useJudge">Evaluate with a judge</label>
                  <p class="field-description" i18n="@@tests.field.useJudge.description">
                    Off — the run passes if the call completed and was not cut off by a limit, silence or an error. On — an LLM also checks the success criteria.
                  </p>
                </div>
                <p-toggleSwitch
                  name="use_judge"
                  [ngModel]="test().use_judge ?? true"
                  (ngModelChange)="setField('use_judge', $event)">
                </p-toggleSwitch>
              </div>
            </div>
          }

          @if (useJudge()) {
          <div class="form-field">
            <label i18n="@@tests.field.criteria">Describe success criteria</label>
            <textarea
              [snAssistantId]="F.successCriteria"
              pTextarea rows="3" [autoResize]="true"
              class="test-edit-textarea"
              i18n-placeholder="@@tests.field.criteria.placeholder"
              placeholder="The agent must collect a phone number…"
              name="success_criteria"
              [ngModel]="test().success_criteria"
              (ngModelChange)="setField('success_criteria', $event)">
            </textarea>
          </div>
          }

          <div class="form-field">
            <label i18n="@@tests.field.maxTurns">Maximum conversation turns</label>
            <p-inputNumber
              [snAssistantId]="F.maxConversationTurns"
              name="max_conversation_turns"
              [ngModel]="test().max_conversation_turns"
              (ngModelChange)="setField('max_conversation_turns', $event)"
              [min]="1" [max]="50" [showButtons]="true">
            </p-inputNumber>
          </div>

          @if (isE2E()) {
            <!-- Режим персоны стоит ДО выбора моделей, потому что он решает,
                 какие модели вообще спрашивать: в Realtime у персоны нет ни
                 отдельной LLM, ни пары STT + TTS. Если спросить их раньше, у
                 пользователя останутся заполненные поля, которые никуда не
                 поедут. -->
            <div class="form-field">
              <label class="field-label" i18n="@@tests.field.callerMode">Caller mode</label>
              <p class="field-description" i18n="@@tests.field.callerMode.description">
                Classic — the caller hears with STT and speaks with TTS. Realtime — one speech-to-speech model does both.
              </p>
              <p-selectButton
                [snAssistantId]="F.callerMode"
                snAssistantOptions="Classic,Realtime"
                [options]="callerModeOptions"
                [ngModel]="test().caller?.mode ?? 'Classic'"
                (ngModelChange)="setCallerMode($event)"
                name="caller_mode"
                optionLabel="label"
                optionValue="value"
                [allowEmpty]="false">
              </p-selectButton>
            </div>
          }

          <div class="form-section-title" i18n="@@tests.section.model">Model configuration</div>

          @if (!isCallerRealtime()) {
          <div class="form-field">
            <label i18n="@@tests.field.simulatedModel">Simulated user model</label>
            <app-model-selector-button
              snAssistantAnchor="simulatedUserModel"
              [modelTypes]="['llm']"
              [modelsHierarchy]="modelsHierarchy()"
              [includeVersionSnapshots]="simulatedUserSnapshots()"
              [selectedVersionId]="test().simulated_user_model_version_id ?? undefined"
              [savedModel]="test().simulated_user_model_version"
              [allowModelSelect]="true"
              [showVersions]="false"
              [allowSelectFromTester]="true"
              [includeAll]="modelsIncludeAll()"
              (includeAllChange)="onModelsIncludeAllChange($event)"
              i18n-label="@@agentEdit.llm.select"
              label="Select LLM Model"
              (modelSelected)="onSimulatedUserModelSelected($event)">
            </app-model-selector-button>
          </div>
          }

          @if (useJudge()) {
          <div class="form-field">
            <label i18n="@@tests.field.evalModel">Conversation evaluation model</label>
            <app-model-selector-button
              snAssistantAnchor="evaluationModel"
              [modelTypes]="['llm']"
              [modelsHierarchy]="modelsHierarchy()"
              [includeVersionSnapshots]="evaluationSnapshots()"
              [selectedVersionId]="test().conversation_evaluation_model_version_id ?? undefined"
              [savedModel]="test().conversation_evaluation_model_version"
              [allowModelSelect]="true"
              [showVersions]="false"
              [allowSelectFromTester]="true"
              [includeAll]="modelsIncludeAll()"
              (includeAllChange)="onModelsIncludeAllChange($event)"
              i18n-label="@@agentEdit.llm.select"
              label="Select LLM Model"
              (modelSelected)="onEvaluationModelSelected($event)">
            </app-model-selector-button>
          </div>
          }

          <!-- Персона: только у E2E. Это КАК ведёт себя машина-клиент, в
               отличие от сценария выше, который говорит ЧЕГО она хочет. -->
          @if (isE2E()) {
            <div class="form-section-title" i18n="@@tests.section.caller">Simulated caller</div>

            <div class="form-field">
              <label i18n="@@tests.field.callerPersona">Caller persona</label>
              <textarea
                [snAssistantId]="F.callerPersona"
                pTextarea rows="3" [autoResize]="true"
                class="test-edit-textarea"
                name="caller_persona"
                i18n-placeholder="@@tests.field.callerPersona.placeholder"
                placeholder="You are Irina, 34, you speak calmly and in short sentences…"
                [ngModel]="test().caller?.persona"
                (ngModelChange)="setCallerField('persona', $event)">
              </textarea>
            </div>

            @if (isCallerRealtime()) {
              <!-- Голос выбирается внутри тестера, рядом с версией модели —
                   как у агента. Отдельного поля под код голоса нет: тестер
                   отдаёт ссылку на справочник, и дублировать её вендорской
                   строкой значило бы держать два источника правды. -->
              <div class="form-field">
                <label i18n="@@tests.field.callerRealtime">Caller speech-to-speech model</label>
                <app-model-selector-button
                  snAssistantAnchor="callerRealtime"
                  [modelTypes]="['realtime']"
                  [modelsHierarchy]="modelsHierarchy()"
                  [includeVersionSnapshots]="callerRealtimeSnapshots()"
                  [selectedVersionId]="test().caller?.realtime_model_version_id ?? undefined"
                  [savedModel]="test().caller?.realtime_model_version"
                  [currentVoiceId]="test().caller?.voice_id"
                  [allowModelSelect]="true"
                  [allowSelectFromTester]="true"
                  [showVersions]="false"
                  [includeAll]="modelsIncludeAll()"
                  (includeAllChange)="onModelsIncludeAllChange($event)"
                  i18n-label="@@tests.field.callerRealtime.select"
                  label="Select realtime model"
                  (modelSelected)="onCallerRealtimeModelSelected($event)"
                  (testerSelected)="onCallerRealtimeTesterSelected($event)">
                </app-model-selector-button>
              </div>
            } @else {
              <div class="form-field">
                <label i18n="@@tests.field.callerStt">Caller speech-to-text model</label>
                <app-model-selector-button
                  snAssistantAnchor="callerStt"
                  [modelTypes]="['stt']"
                  [modelsHierarchy]="modelsHierarchy()"
                  [includeVersionSnapshots]="callerSttSnapshots()"
                  [selectedVersionId]="test().caller?.stt_model_version_id ?? undefined"
                  [savedModel]="test().caller?.stt_model_version"
                  [allowModelSelect]="true"
                  [allowSelectFromTester]="true"
                  [showVersions]="false"
                  [includeAll]="modelsIncludeAll()"
                  (includeAllChange)="onModelsIncludeAllChange($event)"
                  i18n-label="@@tests.field.callerStt.select"
                  label="Select STT model"
                  (modelSelected)="onCallerSttModelSelected($event)"
                  (testerSelected)="onCallerSttModelSelected($event.versionId)">
                </app-model-selector-button>
              </div>

              <div class="form-field">
                <label i18n="@@tests.field.callerTts">Caller text-to-speech model</label>
                <app-model-selector-button
                  snAssistantAnchor="callerTts"
                  [modelTypes]="['tts']"
                  [modelsHierarchy]="modelsHierarchy()"
                  [includeVersionSnapshots]="callerTtsSnapshots()"
                  [selectedVersionId]="test().caller?.tts_model_version_id ?? undefined"
                  [savedModel]="test().caller?.tts_model_version"
                  [currentVoiceId]="test().caller?.voice_id"
                  [allowModelSelect]="true"
                  [allowSelectFromTester]="true"
                  [showVersions]="false"
                  [includeAll]="modelsIncludeAll()"
                  (includeAllChange)="onModelsIncludeAllChange($event)"
                  i18n-label="@@tests.field.callerTts.select"
                  label="Select TTS model"
                  (modelSelected)="onCallerTtsModelSelected($event)"
                  (testerSelected)="onCallerTtsTesterSelected($event)">
                </app-model-selector-button>
              </div>
            }

            <div class="form-field">
              <label i18n="@@tests.field.callerMaxDuration">Max call duration, seconds</label>
              <p-inputNumber
                name="caller_max_duration"
                [min]="10" [max]="1800" [showButtons]="true"
                [ngModel]="test().caller?.max_duration_seconds"
                (ngModelChange)="setCallerField('max_duration_seconds', $event)">
              </p-inputNumber>
            </div>

            <div class="form-field">
              <label i18n="@@tests.field.callerSilenceTimeout">Agent silence timeout, seconds</label>
              <p-inputNumber
                name="caller_silence_timeout"
                [min]="5" [max]="120" [showButtons]="true"
                [ngModel]="test().caller?.silence_timeout_seconds"
                (ngModelChange)="setCallerField('silence_timeout_seconds', $event)">
              </p-inputNumber>
            </div>

            <div class="form-field">
              <div class="switch-field">
                <div class="switch-content">
                  <label class="switch-label" i18n="@@tests.field.callerInterrupt">Caller interrupts the agent</label>
                  <p class="field-description" i18n="@@tests.field.callerInterrupt.description">
                    A real barge-in: exercises interruption handling that a text-only test never touches.
                  </p>
                </div>
                <p-toggleSwitch
                  name="caller_interrupt_agent"
                  [ngModel]="test().caller?.interrupt_agent"
                  (ngModelChange)="setCallerField('interrupt_agent', $event)">
                </p-toggleSwitch>
              </div>
            </div>

            <div class="form-field">
              <div class="switch-field">
                <div class="switch-content">
                  <label class="switch-label" i18n="@@tests.field.callerSpeaksFirst">Caller speaks first</label>
                  <p class="field-description" i18n="@@tests.field.callerSpeaksFirst.description">
                    Off by default — an ordinary call starts with the agent first message.
                  </p>
                </div>
                <p-toggleSwitch
                  name="caller_speaks_first"
                  [ngModel]="test().caller?.caller_speaks_first"
                  (ngModelChange)="setCallerField('caller_speaks_first', $event)">
                </p-toggleSwitch>
              </div>
            </div>
          }

          <!-- Редактор схемы переменных: правка одной строкой невозможна,
               агенту пока не отдаём. -->
          <app-openapi-properties-editor
            snAssistantSkip
            [properties]="localVarProps()"
            (propertiesChange)="onVarPropertiesChange($event)"
            i18n-title="@@tests.field.dynamicVariables"
            title="Dynamic variables"
            [allowedTypes]="['string']">
          </app-openapi-properties-editor>

      </section>

      <!-- RIGHT: conversation chat builder (editable mode) -->
      <section class="chat-pane">
        <app-chat-history-view
          [messages]="test().seed_messages ?? []"
          [editable]="true"
          [showMetrics]="false"
          [showTimestamps]="false"
          (messagesChange)="setField('seed_messages', $event)">
        </app-chat-history-view>
      </section>
    </div>

    <!-- Footer actions -->
    <footer class="test-edit-footer">
      <p-button
        i18n-label="@@common.back"
        label="Back"
        i18n-pTooltip="@@common.back"
        pTooltip="Back"
        tooltipPosition="top"
        i18n-ariaLabel="@@common.back"
        ariaLabel="Back"
        severity="secondary"
        [outlined]="true"
        icon="pi pi-arrow-left"
        (click)="cancel()">
      </p-button>
      <div class="footer-right">
        <p-button
          [label]="saveLabel()"
          [pTooltip]="saveLabel()"
          tooltipPosition="top"
          [ariaLabel]="saveLabel()"
          [icon]="isSaving() ? 'pi pi-spin pi-spinner' : 'pi pi-check'"
          severity="secondary"
          [disabled]="isSaving()"
          [loading]="isSaving()"
          snAssistantAction="save"
          actionHint="Saves the evaluation test. Fields stay unsaved until this runs."
          (click)="save()">
        </p-button>
        <p-button
          i18n-label="@@tests.start"
          label="Start test"
          i18n-pTooltip="@@tests.start"
          pTooltip="Start test"
          tooltipPosition="top"
          i18n-ariaLabel="@@tests.start"
          ariaLabel="Start test"
          icon="pi pi-play"
          severity="primary"
          [disabled]="isSaving()"
          snAssistantAction="saveAndRun"
          actionHint="Saves the test and opens the Run test panel. It does NOT start a run: in the panel pick the agent and press its own run button. A run is a real conversation — it takes time and costs money."
          actionDangerous
          (click)="saveAndRun()">
        </p-button>
      </div>
    </footer>
  }

  <app-run-test-drawer
    [(visible)]="runDrawerVisible"
    [testId]="runTestId()"
    [testName]="runTestName()">
  </app-run-test-drawer>
</div>
